import { AnnotationData } from 'src/packages/react-text-annotator/lib/esm';

export const calculateRenderingLevel = (entities: AnnotationData[]): AnnotationData[] =>
    entities.map(entity => {
        let renderingLevel = 0;
        entities.forEach(e => {
            if (
                e.id !== entity.id &&
                ((e.startToken <= entity.startToken && e.endToken >= entity.startToken) ||
                    (entity.endToken >= e.startToken && entity.endToken <= e.endToken))
            ) {
                renderingLevel = Math.max(renderingLevel, (e.level ?? 0) + 1);
            }
        });
        entity.level = renderingLevel;

        return entity;
    });
